<div class="positions-component">
  <app-table
    (addNewItem)="addNewCategory()"
    (sortColumn)="sortColumn($event)"
    (filterColumn)="getCategoriesFilteredByName($event)"
    (toggleActiveList)="toggleActiveList($event)"
    (showItemDetails)="showItemDetails($event)"
    (showEditModal)="showEditModal($event)"
    (paginationEvent)="paginationEvent($event)"
    (itemsPerPageChange)="onItemsPerPageChange($event)"
    (pageChanged)="onPageChanged($event)"
    [tableData]="tableData"
    [isLoading]="loading"
    [searchText]="searchText"
  >
  </app-table>
  <app-loading-spinner class="spinner" *ngIf="loading"></app-loading-spinner>
</div>
